// extracted by mini-css-extract-plugin
module.exports = {"wrap":"common_wrap_2qjYO","fanhui":"common_fanhui_1a54F","fullScreen":"common_fullScreen_2764p"};